export enum SvcFormCustomFieldType {
  Text = 1,
  Number = 2,
  Date = 3,
  List = 4,
  ListMultiple = 5,
  Checkbox = 6,
  Hour = 7,
  User = 8,
  Location = 9,
  Area = 10,
  Team = 11,
  Hashtag = 12,
  Equipment = 13,
  LongText = 14,
}

export enum SvcFormCustomFieldErrorCode {
  MandatoryField = 'MANDATORY_FIELD',
}
